// Module
var code = `<sub-header header="'Consolidated loans'" tab="true">
  <button class="btn btn-primary"
          type="button"
          ng-disabled="\$ctrl.isInactiveLoanDueToLoanConsolidation()"
          ng-click="\$ctrl.showCustomerSearch()">
    Add new
  </button>
</sub-header>

<validator condition="\$ctrl.hasConsolidatedLoan()" ></validator>
<table class="table table--generate-row-ids" ng-table="\$ctrl.consolidatedLoansTableConfig">
  <tr ng-repeat-start="item in \$ctrl.consolidatedLoans" class="table__row--clickable">
    <td data-title="'No'"></td>
    <td data-title="'Customer name'">{{item.customerName}}</td>
    <td data-title="'Product number'">{{item.productNumber}}</td>
    <td data-title="'Principal'">{{item.principalBalance | nxCurrency}}</td>
    <td data-title="'Interest'">{{item.interestBalance | nxCurrency}}</td>
    <td data-title="'CBU'">{{item.cbuBalance | nxCurrency}}</td>
    <td data-title="'PF'">{{item.pfBalance | nxCurrency}}</td>
    <td data-title="'TP'">{{item.tpBalance | nxCurrency}}</td>
    <td data-title="'Past due interest'">{{item.pastDueInterest | nxCurrency}}</td>
    <td data-title="'Penalties'">{{item.penalty | nxCurrency}}</td>
    <td data-title="'Custom fees'">{{item.customFees | nxCurrency}}</td>
    <td data-title="'Actions'">
      <button class="btn btn-primary action-button"
              type="button"
              ng-disabled="\$ctrl.isInactiveLoanDueToLoanConsolidation()"
              ng-click="\$ctrl.removeRow(\$index, item.loanId)">
        Remove
      </button>
    </td>
    <td data-title="'Waive'">
      <input
             type="checkbox"
             ng-model="item.showWaiveForm" />
    </td>
  </tr>

  <tr ng-repeat-end class="table--skip-generate-row-id" ng-if="item.showWaiveForm" >
    <td></td>
    <td colspan="12">
      <form name="singleWaiveForm">
        <form-section>
          <loan-pre-terminate
            max-values="item.maxValues"
            payment-request="\$ctrl.empty"
            waive-request="item.waiveRequest"
            priority-amortization-ids="item.amortizationIds"
            loan="item.sourceLoan"
            form-name="\$ctrl.waiveForms[\$index]">
          </loan-pre-terminate>
        </form-section>
      </form>
    </td>
  </tr>
  <tfoot>
    <td></td>
    <td colspan="2">Total:</td>
    <td>{{\$ctrl.principal.toNumber() | nxCurrency}}</td>
    <td>{{\$ctrl.interest.toNumber() | nxCurrency}}</td>
    <td>{{\$ctrl.cbu.toNumber() | nxCurrency}}</td>
    <td>{{\$ctrl.pf.toNumber() | nxCurrency}}</td>
    <td>{{\$ctrl.tp.toNumber() | nxCurrency}}</td>
    <td>{{\$ctrl.pdi.toNumber() | nxCurrency}}</td>
    <td>{{\$ctrl.penalty.toNumber() | nxCurrency}}</td>
    <td>{{\$ctrl.customFee.toNumber() | nxCurrency}}</td>
    <td></td>
  </tfoot>
</table>

<modal on-api-ready="\$ctrl.onModalReady"
       ng-if="\$ctrl.customerBranchIdRestriction"
       form="\$ctrl.cancelForm" class="consolidation-popup">
  <modal-header>
    <h2>Search customer</h2>
    <customer-picker
      on-choose="\$ctrl.selectCustomer(customer)"
      search-criteria="{branchIds: \$ctrl.customerBranchIdRestriction}">
    </customer-picker>
  </modal-header>
  <modal-body>
    <table class="table" ng-table="\$ctrl.customerLoansTableConfig">
      <tr ng-repeat="item in \$data"
          class="table__row--clickable">
        <td data-title="'No'">{{\$index + 1 + (\$ctrl.customerLoansTableConfig.page() - 1) * \$ctrl.customerLoansTableConfig.count()}}</td>
        <td data-title="'Product number'">{{item.productNumber}}</td>
        <td data-title="'Product name'">{{item.productDefinition.productName}}</td>
        <td data-title="'Principal amount'">{{item.principalAmount | nxCurrency}}</td>
        <td data-title="'Principal balance'">{{item.principalBalance | nxCurrency}}</td>
        <td data-title="'Status'">{{item.status}}</td>
        <td data-title="'Actions'">
          <button class="btn btn-primary action-button"
                  type="button"
                  ng-disabled="\$ctrl.isLoanAlreadyAdded(item)"
                  ng-click="\$ctrl.addLoan(item)">
            Add
          </button>
        </td>
      </tr>
      <tr ng-if="\$ctrl.selectedCustomer && \$data.length === 0">
        <td colspan="7"><span class="empty-message">Selected customer has no available loans for consolidation.</span></td>
      </tr>
    </table>
  </modal-body>
</modal>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/consolidation/loan-consolidation.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;